import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userAuthSlice";
import notificationsReducer from "./notificationsSlice";

const store = configureStore({
    reducer: {
        user: userReducer,
        notifications: notificationsReducer,
    }
});

export default store;
